import { useState } from 'react';
import "./expandable-box.css";

export default function ExpandableBox({ heading, children, extra_classes, style, content_style, default_open = true }) {
	
   const [ open, setOpen ] = useState( default_open );
	
	return (
		<div
         className={ "expandable-box " + ( extra_classes || "" )}
         style={ style }
      >   
         <div 
            className="expandable-box-head" 
            role="button"
            aria-expanded={open}
            tabIndex={0}
            onClick={() => setOpen( o => !o )}
            onKeyDown={(e) => {
               if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setOpen( o => !o );
               }
            }}
         >
            <div> { heading } </div>

            <span style={{ transform: open ? "rotate(180deg)" : "", transition: "transform .2s" }} aria-hidden="true"> 
               <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30 1.5L16 15.5L2 1.5" strokeWidth="3"/>
               </svg>
            </span>
         </div>

         { open && 
            <div className="expandable-box-content" style={ content_style }> 
               { children }
            </div>
         }
		</div>
	)
}

